export default "__VITE_ASSET__JHA10k9o__"